import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import React from 'react';
import { useTranslation } from 'react-i18next';

import s from './LoadMoreFallback.scss';

export interface Props {
  isActive: boolean;
  fetchNext: () => void;
}

const LoadMoreFallback: React.FC<Props> = ({ isActive, fetchNext }) => {
  const { t } = useTranslation('nc');

  if (!isActive) {
    return null;
  }

  return (
    <div className={s['root']}>
      <GhostButton size="large" variant="main" onClick={() => fetchNext()}>
        {t('nc:common.scrollLoadingFallback.button')}
      </GhostButton>
    </div>
  );
};
LoadMoreFallback.displayName = 'LoadMoreFallback';

export default LoadMoreFallback;
